import type { FC, ReactNode } from 'react';

import { Button, FaceSadIcon } from '@motorway/mw-highway-code';

import styles from './ModalError.module.scss';

interface ModalErrorProps {
	action?: ReactNode;
	description: ReactNode;
	onActionClick?: () => void;
	title: ReactNode;
}

export const ModalError: FC<ModalErrorProps> = ({ action, description, onActionClick, title }) => {
	return (
		<div className={styles.container}>
			<div className={styles.icon}>
				<FaceSadIcon data-thc-icon-face />
			</div>
			<div className={styles.message}>
				<span className={styles.title}>{title}</span>
				<span>{description}</span>
			</div>
			{action && <Button data-thc-button label={action} onClick={() => onActionClick?.()} />}
		</div>
	);
};
